import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { PipScrollableModule } from 'pip-webui2-layouts';
import { PipNavHeaderModule, PipNavModule } from 'pip-webui2-nav';
import { GaSidenavComponent } from './sidenav.component';

@NgModule({
    declarations: [GaSidenavComponent],
    exports: [GaSidenavComponent],
    imports: [
        // Angular and vendors
        CommonModule,
        TranslateModule,
        FlexLayoutModule,
        MatBadgeModule,
        MatDividerModule,
        MatExpansionModule,
        MatListModule,
        MatIconModule,
        MatTooltipModule,
        // pip-suite2 & pip-webui2
        PipNavModule,
        PipNavHeaderModule,
        PipScrollableModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GaSidenavModule { }
